import styled from 'styled-components';

export const ActionsButtonsFooterWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.12);
    border-radius: 1.5rem 1.5rem 0rem 0rem;

    background-color: ${({ theme }) => theme.colors['primary']};

    padding: 0 1rem;
    padding-right: .5rem;
    margin-left: .5rem;
    

    width: calc(100% - 1rem);
    max-height: 30%;
    /* min-height: 9rem; */
    flex-shrink: 0;

    overflow: scroll; /* Permite a rolagem em telas menores */
    scrollbar-width: none; /* Esconde a barra de rolagem no Firefox */

    &::-webkit-scrollbar {
        display: none; /* Esconde a barra de rolagem no Webkit (Chrome, Safari) */
    }
`;

export const ValuesWrap = styled.div`
    display: flex;
    flex-direction: column;
    /* background-color: blue; */
    overflow: auto;
    
    flex: 1;

    gap: 1rem;

    border-bottom: 2px dotted ${({ theme }) => theme.colors['silver-200']};
    

    padding: 0.75rem 0;
    padding-right: 0;

    span {
        font-size: 1.2rem;
    }

    > * {
        margin-right: 1rem;
    }
`;

export const ValuesNumbersWrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
        font-size: 1.2rem;
    }
`;

export const ElementTotalSum = styled.div`
    display: flex;
    width: 100%;

    justify-content: space-between;
    align-items: center;

    color: ${({ theme }) => theme.colors['neutral-800']};

    span {
        font-size: 1.2rem;
    }
`;

export const WrapElementsCartSmallScreen = styled.div`
    display: flex;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors['silver-500']};
    padding-top: 1rem;
    border-top: 2px solid ${({ theme }) => theme.colors['silver-200']};

    & > div:first-child {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 0.7rem;

        h2 {
            font-size: 1rem;
            font-weight: 500;
            line-height: 1.2rem;
            color: ${({ theme }) => theme.colors['neutral-800']};
        }
    }
`;

export const WrapIconText = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 1rem;
`;

export const TextDate = styled.span`
    font-size: 0.75rem !important;
    font-weight: 400;

    line-height: 14px;
    text-align: left;
`;

export const TextValue = styled.span`
    font-size: 1rem !important;

    font-weight: 500;

    line-height: 18px;
    text-align: left;
`;

export const ContainerWrap = styled.div`
    /* padding-bottom: 6rem; */
`;

type ButtonsWrapperProps = {
    isVisible: boolean;
};

export const ButtonsWrapper = styled.div<ButtonsWrapperProps>`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
    height: auto;


    bottom: 1rem;

    transition:
        transform 0.5s,
        opacity 0.5s;
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
`;
